<template>
    <div class="page-container">
        <div class="condition-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item>
                    <el-input v-model="queryParams.printerUsername" clearable placeholder="请输入设备编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryParams.iccid" clearable placeholder="请输入ICCID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryParams.simStatus" clearable placeholder="请选择卡状态">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-container">
            <el-table v-loading="loading" :data="list" stripe border>
                <div slot="empty">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <el-table-column label="设备类型" width="100">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.type==1">云打印机</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.type==2">蓝牙云盒</el-tag>
                        <el-tag type="danger" v-else>其他</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="printerUsername" label="设备编号"></el-table-column>
                <el-table-column prop="iccid" label="ICCID"></el-table-column>
                <el-table-column prop="simExpireTime" label="到期时间" width="180"></el-table-column>
                <el-table-column label="状态" width="120">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.simStatus==1">正常</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.simStatus==2">即将到期</el-tag>
                        <el-tag type="danger" v-else-if="scope.row.simStatus==4">已过期</el-tag>
                        <el-tag type="info" v-else>其他</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="showForm(scope.row)">充值
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paging-container paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum" :page-sizes="$pageSizes" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>


<script>
var moment = require('moment');

export default {
    data() {
        return {
            loading: false,
            headers: null,
            statusOptions: [{
                value: 1,
                label: "正常（过期时间>=30天）"
            }, {
                value: 2,
                label: "即将到期（过期时间<30天）"
            }, {
                value: 3,
                label: "正常+即将到期"
            }, {
                value: 4,
                label: "已过期"
            }],
            queryParams: {
                pageNum: 1,
                printerUsername: null,
                iccid: null,
                simStatus: null
            },
            total: 0,
            list: []
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        let loginInfo = JSON.parse(loginInfoStr);
        let developer = loginInfo.developer;
        let token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    methods: {
        handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query(pageNum) {
            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listSim", {
                params: this.queryParams,
                headers: this.headers
            }).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.total = res.data.total;
                    let result = res.data.rows;
                    result.forEach(element => {
                        let simExpireTime = element.simExpireTime;
                        element.simExpireTime = moment(simExpireTime).format("YYYY-MM-DD");
                        let diffDay = moment(simExpireTime).diff(moment(), 'days');
                        if (diffDay < 0) {
                            element.simStatus = 4;
                        } else if (diffDay < 30) {
                            element.simStatus = 2;
                        } else {
                            element.simStatus = 1;
                        }
                    });
                    this.list = result;
                }
            });
        },
        showForm() {
            this.$showWarnMsg("亲，此功能暂未开放哦~");
        }
    }
}
</script>


<style scoped>
.page-container {
    height: 100%;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

.data-container {
    overflow-y: scroll;
}

.detail {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// sim.vue?9f01baf0